import { render, staticRenderFns } from "./resistenzen-rueckmeldung.vue?vue&type=template&id=71ac6385&scoped=true&"
import script from "./resistenzen-rueckmeldung.vue?vue&type=script&lang=js&"
export * from "./resistenzen-rueckmeldung.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ac6385",
  null
  
)

export default component.exports